import { Bedtime } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { IRatioItem } from "./table-ratios.models";
import { isOvernightRatioWindow } from "./table-ratios.utils";

/** Marks a window that closes after midnight; renders nothing for an ordinary same-day window. */
export const RatioOvernightMarker: FC<Pick<IRatioItem, "from" | "to">> = ({
  from,
  to,
}) => {
  const { t } = useTranslation();

  if (!isOvernightRatioWindow({ from, to })) {
    return null;
  }

  return (
    <Tooltip title={t("area.ratioWindowNextDay")}>
      <Bedtime fontSize="inherit" />
    </Tooltip>
  );
};
